import api from './api';
import { toast } from 'sonner';

export async function startWhop() {
  try {
    const { data } = await api.get('/auth/whop/start', { params: { flow: 'web' } });
    if (data?.authorize_url) {
      window.location.href = data.authorize_url;
      return true;
    }
    toast.error('Whop sign-in is unavailable right now.');
  } catch (e) {
    if (e?.response?.status === 503) {
      toast.error("Whop sign-in isn't configured in this environment yet.");
    } else {
      toast.error('Could not start Whop sign-in. Please try again.');
    }
  }
  return false;
}
